const skuEncoder = (sku) => {
  while (sku.includes('/') || sku.includes('%2F')) {
    sku = sku.replace('/', '-v-').replace('%2F', '-v-');
  }
  return encodeURIComponent(sku);
};

export default skuEncoder;
